/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type SocialPostClassMutationVariables = Types.Exact<{
  input: Types.SocialPostInput;
}>;


export type SocialPostClassMutation = { __typename?: 'Mutation', socialPostClass: { __typename?: 'SocialPostResponse', success: boolean, post?: { __typename?: 'Post', id: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialPostProjectMutationVariables = Types.Exact<{
  input: Types.SocialPostInput;
}>;


export type SocialPostProjectMutation = { __typename?: 'Mutation', socialPostProject: { __typename?: 'SocialPostResponse', success: boolean, post?: { __typename?: 'Post', id: string, postSlug?: string | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialUploadsCreateSignedUrlMutationVariables = Types.Exact<{
  input: Types.SocialCreateSignedUploadUrlV2Input;
}>;


export type SocialUploadsCreateSignedUrlMutation = { __typename?: 'Mutation', socialCreateSignedUploadUrlV2: { __typename?: 'SocialCreateSignedUploadUrlV2Response', id: string, signedUrl: string, inputFormFields?: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialGetUploadedQueryVariables = Types.Exact<{
  input: Types.SocialGetUploadedInput;
}>;


export type SocialGetUploadedQuery = { __typename?: 'Query', socialGetUploaded: { __typename?: 'SocialGetUploadedResponse', imageUrl?: string | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialGetUsersQueryVariables = Types.Exact<{
  input: Types.SocialGetUsersInput;
}>;


export type SocialGetUsersQuery = { __typename?: 'Query', socialGetUsers: { __typename?: 'SocialGetUsersResponse', users?: Array<{ __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, superSkill?: string | null, following: boolean, isTemporary: boolean, isBanned?: boolean | null, isProfilePublic?: boolean | null }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialUserFeedQueryVariables = Types.Exact<{
  input: Types.SocialUserFeedInput;
}>;


export type SocialUserFeedQuery = { __typename?: 'Query', socialUserFeed: { __typename?: 'SocialFeedResponse', posts?: Array<{ __typename?: 'Post', id: string, postSlug?: string | null, content: string, likesCount: number, isLiked: boolean, commentsCount: number, isSaved: boolean, type: Types.PostType, machines?: Array<string | null> | null, materials?: Array<string | null> | null, instructions?: Array<string | null> | null, createTime: any, level?: Types.ProjectLevel | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, superSkill?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, socialProducts?: Array<{ __typename?: 'SocialProduct', id: string, title: string, thumbnail?: string | null, slug: string, description: string, category: string, categorySlug: string, author: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null } }> | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, machineItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null, type?: string | null }> | null, materialItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, themeItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, instructionItems?: Array<{ __typename?: 'SocialInstruction', description?: string | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null }> | null }> | null, pagination?: { __typename?: 'SocialFeedPagination', totalPages: number, itemsPerPage: number, nextPageCursor?: number | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialDiscoveryFeedQueryVariables = Types.Exact<{
  input: Types.SocialDiscoveryFeedInput;
}>;


export type SocialDiscoveryFeedQuery = { __typename?: 'Query', socialDiscoveryFeed: { __typename?: 'SocialFeedResponse', posts?: Array<{ __typename?: 'Post', id: string, postSlug?: string | null, content: string, likesCount: number, isLiked: boolean, isSaved: boolean, commentsCount: number, type: Types.PostType, machines?: Array<string | null> | null, materials?: Array<string | null> | null, instructions?: Array<string | null> | null, createTime: any, themes?: Array<string | null> | null, level?: Types.ProjectLevel | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, socialProducts?: Array<{ __typename?: 'SocialProduct', id: string, title: string, thumbnail?: string | null, slug: string, description: string, category: string, categorySlug: string, author: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null } }> | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, machineItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null, type?: string | null }> | null, materialItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, themeItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, instructionItems?: Array<{ __typename?: 'SocialInstruction', description?: string | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null }> | null }> | null, pagination?: { __typename?: 'SocialFeedPagination', totalPages: number, itemsPerPage: number, nextPageCursor?: number | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialGetPostQueryVariables = Types.Exact<{
  input: Types.SocialGetPostInput;
}>;


export type SocialGetPostQuery = { __typename?: 'Query', socialGetPost: { __typename?: 'SocialPostResponse', success: boolean, post?: { __typename?: 'Post', id: string, postSlug?: string | null, content: string, likesCount: number, isLiked: boolean, isSaved: boolean, commentsCount: number, type: Types.PostType, level?: Types.ProjectLevel | null, machines?: Array<string | null> | null, materials?: Array<string | null> | null, instructions?: Array<string | null> | null, createTime: any, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, socialProducts?: Array<{ __typename?: 'SocialProduct', id: string, title: string, thumbnail?: string | null, slug: string, description: string, category: string, categorySlug: string, author: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null } }> | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, machineItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null, type?: string | null }> | null, materialItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, themeItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, instructionItems?: Array<{ __typename?: 'SocialInstruction', description?: string | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null }> | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialGiveTipToAnswerMutationVariables = Types.Exact<{
  input: Types.SocialGiveTipToPostInput;
}>;


export type SocialGiveTipToAnswerMutation = { __typename?: 'Mutation', socialGiveTipToPost: { __typename?: 'SocialGiveTipToPostResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialCommentPostMutationVariables = Types.Exact<{
  input: Types.SocialCreateCommentInput;
}>;


export type SocialCommentPostMutation = { __typename?: 'Mutation', socialCreateComment: { __typename?: 'SocialCreateCommentResponse', success: boolean, comment?: { __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean }, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType }> | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialListCommentsQueryVariables = Types.Exact<{
  input: Types.SocialCommentsListInput;
}>;


export type SocialListCommentsQuery = { __typename?: 'Query', socialListComments: { __typename?: 'SocialCommentsListResponse', comments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean }, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null }> | null, pagination?: { __typename?: 'SocialCommentListPagination', nextPageCursor: any, hasNextPage: boolean } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialGetCommentQueryVariables = Types.Exact<{
  input: Types.SocialGetCommentInput;
}>;


export type SocialGetCommentQuery = { __typename?: 'Query', socialGetComment: { __typename?: 'SocialGetCommentResponse', success: boolean, comment?: { __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, superSkill?: string | null, following: boolean, isTemporary: boolean, isBanned?: boolean | null, isProfilePublic?: boolean | null }, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialDeletePostMutationVariables = Types.Exact<{
  input: Types.SocialPostDeleteInput;
}>;


export type SocialDeletePostMutation = { __typename?: 'Mutation', socialPostDelete: { __typename?: 'SocialPostDeleteResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialDeleteCommentMutationVariables = Types.Exact<{
  input: Types.SocialCommentDeleteInput;
}>;


export type SocialDeleteCommentMutation = { __typename?: 'Mutation', socialCommentDelete: { __typename?: 'SocialCommentDeleteResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialFollowersFeedQueryVariables = Types.Exact<{
  input: Types.SocialFollowersFeedInput;
}>;


export type SocialFollowersFeedQuery = { __typename?: 'Query', socialFollowersFeed: { __typename?: 'SocialFeedResponse', posts?: Array<{ __typename?: 'Post', id: string, postSlug?: string | null, content: string, likesCount: number, isLiked: boolean, isSaved: boolean, commentsCount: number, type: Types.PostType, machines?: Array<string | null> | null, materials?: Array<string | null> | null, instructions?: Array<string | null> | null, createTime: any, level?: Types.ProjectLevel | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, socialProducts?: Array<{ __typename?: 'SocialProduct', id: string, title: string, thumbnail?: string | null, slug: string, description: string, category: string, categorySlug: string, author: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null } }> | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, machineItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null, type?: string | null }> | null, materialItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, themeItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, instructionItems?: Array<{ __typename?: 'SocialInstruction', description?: string | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null }> | null }> | null, pagination?: { __typename?: 'SocialFeedPagination', totalPages: number, itemsPerPage: number, nextPageCursor?: number | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialSavedFeedQueryVariables = Types.Exact<{
  input: Types.SocialSavedFeedInput;
}>;


export type SocialSavedFeedQuery = { __typename?: 'Query', socialSavedFeed: { __typename?: 'SocialSavedFeedResponse', totalSavedPosts: number, posts?: Array<{ __typename?: 'Post', id: string, postSlug?: string | null, content: string, likesCount: number, isLiked: boolean, isSaved: boolean, commentsCount: number, type: Types.PostType, machines?: Array<string | null> | null, materials?: Array<string | null> | null, instructions?: Array<string | null> | null, createTime: any, level?: Types.ProjectLevel | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, socialProducts?: Array<{ __typename?: 'SocialProduct', id: string, title: string, thumbnail?: string | null, slug: string, description: string, category: string, categorySlug: string, author: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null } }> | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, machineItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null, type?: string | null }> | null, materialItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, themeItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, instructionItems?: Array<{ __typename?: 'SocialInstruction', description?: string | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null }> | null }> | null, pagination: { __typename?: 'SocialFeedPagination', totalPages: number, itemsPerPage: number, nextPageCursor?: number | null }, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialCuratedFeedQueryVariables = Types.Exact<{
  input: Types.SocialCuratedFeedInput;
}>;


export type SocialCuratedFeedQuery = { __typename?: 'Query', socialCuratedFeed: { __typename?: 'SocialCuratedFeedResponse', posts?: Array<{ __typename?: 'Post', id: string, postSlug?: string | null, content: string, likesCount: number, isLiked: boolean, isSaved: boolean, commentsCount: number, type: Types.PostType, machines?: Array<string | null> | null, materials?: Array<string | null> | null, instructions?: Array<string | null> | null, createTime: any, themes?: Array<string | null> | null, level?: Types.ProjectLevel | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, socialProducts?: Array<{ __typename?: 'SocialProduct', id: string, title: string, thumbnail?: string | null, slug: string, description: string, category: string, categorySlug: string, author: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null } }> | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, machineItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null, type?: string | null }> | null, materialItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, themeItems?: Array<{ __typename?: 'DropdownItem', id?: number | null, title?: string | null }> | null, instructionItems?: Array<{ __typename?: 'SocialInstruction', description?: string | null, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null }> | null }> | null, pagination?: { __typename?: 'SocialCuratedFeedPagination', totalPages: number, itemsPerPage: number, nextPageCursor?: number | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type CreateSocialCommentMutationVariables = Types.Exact<{
  input: Types.SocialCreateCommentInput;
}>;


export type CreateSocialCommentMutation = { __typename?: 'Mutation', socialCreateComment: { __typename?: 'SocialCreateCommentResponse', success: boolean, comment?: { __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, superSkill?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean }, assets?: Array<{ __typename?: 'SocialAsset', id: string, url: string, optimizedUrl?: string | null, type: Types.SocialAssetType, createTime?: any | null, thumbnailUrls?: Array<{ __typename?: 'Thumbnail', url: string, width: number }> | null, videoInfo?: { __typename?: 'SocialVideoAsset', id: string, state: Types.VideoState, hls_urls: Array<string>, mp4_urls: Array<string>, dash_urls: Array<string>, thumbnailUrl?: string | null } | null }> | null, childComments?: Array<{ __typename?: 'SocialComment', id: string, content: string, commentsCount: number, likesCount: number, createTime: any, isLiked: boolean }> | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };


export const SocialPostClassDocument = `
mutation socialPostClass($input: SocialPostInput!) {
  socialPostClass(input: $input) {
    success
    post {
      id
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialPostClassMutationKey = 'socialPostClass'

export function socialPostClassMutationFetcher(variables: SocialPostClassMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialPostClassMutation, SocialPostClassMutationVariables>(SocialPostClassDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialPostClassMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialPostClassMutation, E, SocialPostClassMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialPostClassMutation, E, SocialPostClassMutationVariables, C>({
        ...options,
        mutationKey: [socialPostClassMutationKey],
        mutationFn: (variables: SocialPostClassMutationVariables) => socialPostClassMutationFetcher(variables, fetchOptions),
    })
}

export const SocialPostProjectDocument = `
mutation socialPostProject($input: SocialPostInput!) {
  socialPostProject(input: $input) {
    success
    post {
      id
      postSlug
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialPostProjectMutationKey = 'socialPostProject'

export function socialPostProjectMutationFetcher(variables: SocialPostProjectMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialPostProjectMutation, SocialPostProjectMutationVariables>(SocialPostProjectDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialPostProjectMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialPostProjectMutation, E, SocialPostProjectMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialPostProjectMutation, E, SocialPostProjectMutationVariables, C>({
        ...options,
        mutationKey: [socialPostProjectMutationKey],
        mutationFn: (variables: SocialPostProjectMutationVariables) => socialPostProjectMutationFetcher(variables, fetchOptions),
    })
}

export const SocialUploadsCreateSignedUrlDocument = `
mutation socialUploadsCreateSignedUrl($input: SocialCreateSignedUploadUrlV2Input!) {
  socialCreateSignedUploadUrlV2(input: $input) {
    id
    signedUrl
    inputFormFields {
      key
      value
    }
    errors {
      code
      message
    }
  }
}

`

export const socialUploadsCreateSignedUrlMutationKey = 'socialUploadsCreateSignedUrl'

export function socialUploadsCreateSignedUrlMutationFetcher(variables: SocialUploadsCreateSignedUrlMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialUploadsCreateSignedUrlMutation, SocialUploadsCreateSignedUrlMutationVariables>(SocialUploadsCreateSignedUrlDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialUploadsCreateSignedUrlMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialUploadsCreateSignedUrlMutation, E, SocialUploadsCreateSignedUrlMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialUploadsCreateSignedUrlMutation, E, SocialUploadsCreateSignedUrlMutationVariables, C>({
        ...options,
        mutationKey: [socialUploadsCreateSignedUrlMutationKey],
        mutationFn: (variables: SocialUploadsCreateSignedUrlMutationVariables) => socialUploadsCreateSignedUrlMutationFetcher(variables, fetchOptions),
    })
}

export const SocialGiveTipToAnswerDocument = `
mutation socialGiveTipToAnswer($input: SocialGiveTipToPostInput!) {
  socialGiveTipToPost(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialGiveTipToAnswerMutationKey = 'socialGiveTipToAnswer'

export function socialGiveTipToAnswerMutationFetcher(variables: SocialGiveTipToAnswerMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialGiveTipToAnswerMutation, SocialGiveTipToAnswerMutationVariables>(SocialGiveTipToAnswerDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialGiveTipToAnswerMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialGiveTipToAnswerMutation, E, SocialGiveTipToAnswerMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialGiveTipToAnswerMutation, E, SocialGiveTipToAnswerMutationVariables, C>({
        ...options,
        mutationKey: [socialGiveTipToAnswerMutationKey],
        mutationFn: (variables: SocialGiveTipToAnswerMutationVariables) => socialGiveTipToAnswerMutationFetcher(variables, fetchOptions),
    })
}

export const SocialCommentPostDocument = `
mutation socialCommentPost($input: SocialCreateCommentInput!) {
  socialCreateComment(input: $input) {
    success
    comment {
      id
      content
      commentsCount
      likesCount
      createTime
      isLiked
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
      }
      assets {
        id
        url
        optimizedUrl
        type
      }
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
      }
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialCommentPostMutationKey = 'socialCommentPost'

export function socialCommentPostMutationFetcher(variables: SocialCommentPostMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialCommentPostMutation, SocialCommentPostMutationVariables>(SocialCommentPostDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialCommentPostMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialCommentPostMutation, E, SocialCommentPostMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialCommentPostMutation, E, SocialCommentPostMutationVariables, C>({
        ...options,
        mutationKey: [socialCommentPostMutationKey],
        mutationFn: (variables: SocialCommentPostMutationVariables) => socialCommentPostMutationFetcher(variables, fetchOptions),
    })
}

export const SocialDeletePostDocument = `
mutation socialDeletePost($input: SocialPostDeleteInput!) {
  socialPostDelete(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialDeletePostMutationKey = 'socialDeletePost'

export function socialDeletePostMutationFetcher(variables: SocialDeletePostMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialDeletePostMutation, SocialDeletePostMutationVariables>(SocialDeletePostDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialDeletePostMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialDeletePostMutation, E, SocialDeletePostMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialDeletePostMutation, E, SocialDeletePostMutationVariables, C>({
        ...options,
        mutationKey: [socialDeletePostMutationKey],
        mutationFn: (variables: SocialDeletePostMutationVariables) => socialDeletePostMutationFetcher(variables, fetchOptions),
    })
}

export const SocialDeleteCommentDocument = `
mutation socialDeleteComment($input: SocialCommentDeleteInput!) {
  socialCommentDelete(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialDeleteCommentMutationKey = 'socialDeleteComment'

export function socialDeleteCommentMutationFetcher(variables: SocialDeleteCommentMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialDeleteCommentMutation, SocialDeleteCommentMutationVariables>(SocialDeleteCommentDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialDeleteCommentMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialDeleteCommentMutation, E, SocialDeleteCommentMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialDeleteCommentMutation, E, SocialDeleteCommentMutationVariables, C>({
        ...options,
        mutationKey: [socialDeleteCommentMutationKey],
        mutationFn: (variables: SocialDeleteCommentMutationVariables) => socialDeleteCommentMutationFetcher(variables, fetchOptions),
    })
}

export const CreateSocialCommentDocument = `
mutation createSocialComment($input: SocialCreateCommentInput!) {
  socialCreateComment(input: $input) {
    success
    comment {
      id
      content
      commentsCount
      likesCount
      createTime
      isLiked
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        createTime
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
      }
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const createSocialCommentMutationKey = 'createSocialComment'

export function createSocialCommentMutationFetcher(variables: CreateSocialCommentMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<CreateSocialCommentMutation, CreateSocialCommentMutationVariables>(CreateSocialCommentDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useCreateSocialCommentMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<CreateSocialCommentMutation, E, CreateSocialCommentMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<CreateSocialCommentMutation, E, CreateSocialCommentMutationVariables, C>({
        ...options,
        mutationKey: [createSocialCommentMutationKey],
        mutationFn: (variables: CreateSocialCommentMutationVariables) => createSocialCommentMutationFetcher(variables, fetchOptions),
    })
}

export const SocialGetUploadedDocument = `
query socialGetUploaded($input: SocialGetUploadedInput!) {
  socialGetUploaded(input: $input) {
    imageUrl
    errors {
      code
      message
    }
  }
}

`

export const socialGetUploadedQueryRootKey = 'socialGetUploaded'

export function socialGetUploadedQueryFetcher(variables: SocialGetUploadedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialGetUploadedQuery, SocialGetUploadedQueryVariables>(SocialGetUploadedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialGetUploadedQueryKey(variables: SocialGetUploadedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialGetUploadedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialGetUploadedQueryOptions(
    variables: SocialGetUploadedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialGetUploadedQuery, unknown, SocialGetUploadedQuery, (SocialGetUploadedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialGetUploadedQueryKey(variables, fetchOptions),
        queryFn: socialGetUploadedQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialGetUploadedQuery<D = SocialGetUploadedQuery, E = unknown>(
    variables: SocialGetUploadedQueryVariables,
    options?: Omit<UseQueryOptions<SocialGetUploadedQuery, E, D, (SocialGetUploadedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialGetUploadedQuery, E, D, (SocialGetUploadedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialGetUploadedQueryOptions(variables, fetchOptions),
    })
}

export const SocialGetUsersDocument = `
query socialGetUsers($input: SocialGetUsersInput!) {
  socialGetUsers(input: $input) {
    users {
      id
      slug
      displayName
      firstName
      lastName
      shopName
      avatarUrl
      isCreativeFabrica
      isVerified
      isPremium
      isFollowed
      superSkill
      following
      isTemporary
      isBanned
      isProfilePublic
    }
    errors {
      code
      message
    }
  }
}

`

export const socialGetUsersQueryRootKey = 'socialGetUsers'

export function socialGetUsersQueryFetcher(variables: SocialGetUsersQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialGetUsersQuery, SocialGetUsersQueryVariables>(SocialGetUsersDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialGetUsersQueryKey(variables: SocialGetUsersQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialGetUsersQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialGetUsersQueryOptions(
    variables: SocialGetUsersQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialGetUsersQuery, unknown, SocialGetUsersQuery, (SocialGetUsersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialGetUsersQueryKey(variables, fetchOptions),
        queryFn: socialGetUsersQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialGetUsersQuery<D = SocialGetUsersQuery, E = unknown>(
    variables: SocialGetUsersQueryVariables,
    options?: Omit<UseQueryOptions<SocialGetUsersQuery, E, D, (SocialGetUsersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialGetUsersQuery, E, D, (SocialGetUsersQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialGetUsersQueryOptions(variables, fetchOptions),
    })
}

export const SocialUserFeedDocument = `
query socialUserFeed($input: SocialUserFeedInput!) {
  socialUserFeed(input: $input) {
    posts {
      id
      postSlug
      content
      likesCount
      isLiked
      commentsCount
      isSaved
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
        childComments {
          id
          content
          commentsCount
          likesCount
          createTime
          isLiked
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        superSkill
        avatarUrl
        profileUrls {
          crafter
          designer
          teacher
          theArtistry
        }
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        location {
          country
        }
        following
        isTemporary
      }
      type
      socialProducts {
        id
        title
        thumbnail
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          profileUrls {
            crafter
            designer
            teacher
            theArtistry
          }
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
        }
        slug
        description
        category
        categorySlug
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      machines
      materials
      instructions
      createTime
      level
      machineItems {
        id
        title
        type
      }
      materialItems {
        id
        title
      }
      themeItems {
        id
        title
      }
      instructionItems {
        description
        assets {
          id
          url
          optimizedUrl
          thumbnailUrls {
            url
            width
          }
          type
          createTime
          videoInfo {
            id
            state
            hls_urls
            mp4_urls
            dash_urls
            thumbnailUrl
          }
        }
      }
    }
    pagination {
      totalPages
      itemsPerPage
      nextPageCursor
    }
    errors {
      code
      message
    }
  }
}

`

export const socialUserFeedQueryRootKey = 'socialUserFeed'

export function socialUserFeedQueryFetcher(variables: SocialUserFeedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialUserFeedQuery, SocialUserFeedQueryVariables>(SocialUserFeedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialUserFeedQueryKey(variables: SocialUserFeedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialUserFeedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialUserFeedQueryOptions(
    variables: SocialUserFeedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialUserFeedQuery, unknown, SocialUserFeedQuery, (SocialUserFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialUserFeedQueryKey(variables, fetchOptions),
        queryFn: socialUserFeedQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialUserFeedQuery<D = SocialUserFeedQuery, E = unknown>(
    variables: SocialUserFeedQueryVariables,
    options?: Omit<UseQueryOptions<SocialUserFeedQuery, E, D, (SocialUserFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialUserFeedQuery, E, D, (SocialUserFeedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialUserFeedQueryOptions(variables, fetchOptions),
    })
}

export const SocialDiscoveryFeedDocument = `
query socialDiscoveryFeed($input: SocialDiscoveryFeedInput!) {
  socialDiscoveryFeed(input: $input) {
    posts {
      id
      postSlug
      content
      likesCount
      isLiked
      isSaved
      commentsCount
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
        childComments {
          id
          content
          commentsCount
          likesCount
          createTime
          isLiked
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        profileUrls {
          crafter
          designer
          teacher
          theArtistry
        }
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        location {
          country
        }
        following
        isTemporary
      }
      type
      socialProducts {
        id
        title
        thumbnail
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          profileUrls {
            crafter
            designer
            teacher
            theArtistry
          }
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
        }
        slug
        description
        category
        categorySlug
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      machines
      materials
      instructions
      createTime
      themes
      level
      machineItems {
        id
        title
        type
      }
      materialItems {
        id
        title
      }
      themeItems {
        id
        title
      }
      instructionItems {
        description
        assets {
          id
          url
          optimizedUrl
          thumbnailUrls {
            url
            width
          }
          type
          createTime
          videoInfo {
            id
            state
            hls_urls
            mp4_urls
            dash_urls
            thumbnailUrl
          }
        }
      }
    }
    pagination {
      totalPages
      itemsPerPage
      nextPageCursor
    }
    errors {
      code
      message
    }
  }
}

`

export const socialDiscoveryFeedQueryRootKey = 'socialDiscoveryFeed'

export function socialDiscoveryFeedQueryFetcher(variables: SocialDiscoveryFeedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialDiscoveryFeedQuery, SocialDiscoveryFeedQueryVariables>(SocialDiscoveryFeedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialDiscoveryFeedQueryKey(variables: SocialDiscoveryFeedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialDiscoveryFeedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialDiscoveryFeedQueryOptions(
    variables: SocialDiscoveryFeedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialDiscoveryFeedQuery, unknown, SocialDiscoveryFeedQuery, (SocialDiscoveryFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialDiscoveryFeedQueryKey(variables, fetchOptions),
        queryFn: socialDiscoveryFeedQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialDiscoveryFeedQuery<D = SocialDiscoveryFeedQuery, E = unknown>(
    variables: SocialDiscoveryFeedQueryVariables,
    options?: Omit<UseQueryOptions<SocialDiscoveryFeedQuery, E, D, (SocialDiscoveryFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialDiscoveryFeedQuery, E, D, (SocialDiscoveryFeedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialDiscoveryFeedQueryOptions(variables, fetchOptions),
    })
}

export const SocialGetPostDocument = `
query socialGetPost($input: SocialGetPostInput!) {
  socialGetPost(input: $input) {
    post {
      id
      postSlug
      content
      likesCount
      isLiked
      isSaved
      commentsCount
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
        childComments {
          id
          content
          commentsCount
          likesCount
          createTime
          isLiked
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        profileUrls {
          crafter
          designer
          teacher
          theArtistry
        }
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        location {
          country
        }
        following
        isTemporary
      }
      type
      socialProducts {
        id
        title
        thumbnail
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          profileUrls {
            crafter
            designer
            teacher
            theArtistry
          }
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
        }
        slug
        description
        category
        categorySlug
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      level
      machines
      materials
      instructions
      createTime
      machineItems {
        id
        title
        type
      }
      materialItems {
        id
        title
      }
      themeItems {
        id
        title
      }
      instructionItems {
        description
        assets {
          id
          url
          optimizedUrl
          thumbnailUrls {
            url
            width
          }
          type
          createTime
          videoInfo {
            id
            state
            hls_urls
            mp4_urls
            dash_urls
            thumbnailUrl
          }
        }
      }
    }
    success
    errors {
      code
      message
    }
  }
}

`

export const socialGetPostQueryRootKey = 'socialGetPost'

export function socialGetPostQueryFetcher(variables: SocialGetPostQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialGetPostQuery, SocialGetPostQueryVariables>(SocialGetPostDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialGetPostQueryKey(variables: SocialGetPostQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialGetPostQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialGetPostQueryOptions(
    variables: SocialGetPostQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialGetPostQuery, unknown, SocialGetPostQuery, (SocialGetPostQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialGetPostQueryKey(variables, fetchOptions),
        queryFn: socialGetPostQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialGetPostQuery<D = SocialGetPostQuery, E = unknown>(
    variables: SocialGetPostQueryVariables,
    options?: Omit<UseQueryOptions<SocialGetPostQuery, E, D, (SocialGetPostQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialGetPostQuery, E, D, (SocialGetPostQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialGetPostQueryOptions(variables, fetchOptions),
    })
}

export const SocialListCommentsDocument = `
query socialListComments($input: SocialCommentsListInput!) {
  socialListComments(input: $input) {
    comments {
      id
      content
      commentsCount
      likesCount
      createTime
      isLiked
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        createTime
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
      }
    }
    pagination {
      nextPageCursor
      hasNextPage
    }
    errors {
      code
      message
    }
  }
}

`

export const socialListCommentsQueryRootKey = 'socialListComments'

export function socialListCommentsQueryFetcher(variables: SocialListCommentsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialListCommentsQuery, SocialListCommentsQueryVariables>(SocialListCommentsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialListCommentsQueryKey(variables: SocialListCommentsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialListCommentsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialListCommentsQueryOptions(
    variables: SocialListCommentsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialListCommentsQuery, unknown, SocialListCommentsQuery, (SocialListCommentsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialListCommentsQueryKey(variables, fetchOptions),
        queryFn: socialListCommentsQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialListCommentsQuery<D = SocialListCommentsQuery, E = unknown>(
    variables: SocialListCommentsQueryVariables,
    options?: Omit<UseQueryOptions<SocialListCommentsQuery, E, D, (SocialListCommentsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialListCommentsQuery, E, D, (SocialListCommentsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialListCommentsQueryOptions(variables, fetchOptions),
    })
}

export const SocialGetCommentDocument = `
query socialGetComment($input: SocialGetCommentInput!) {
  socialGetComment(input: $input) {
    comment {
      id
      content
      commentsCount
      likesCount
      createTime
      isLiked
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        superSkill
        following
        isTemporary
        isBanned
        isProfilePublic
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        createTime
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
      }
    }
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialGetCommentQueryRootKey = 'socialGetComment'

export function socialGetCommentQueryFetcher(variables: SocialGetCommentQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialGetCommentQuery, SocialGetCommentQueryVariables>(SocialGetCommentDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialGetCommentQueryKey(variables: SocialGetCommentQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialGetCommentQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialGetCommentQueryOptions(
    variables: SocialGetCommentQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialGetCommentQuery, unknown, SocialGetCommentQuery, (SocialGetCommentQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialGetCommentQueryKey(variables, fetchOptions),
        queryFn: socialGetCommentQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialGetCommentQuery<D = SocialGetCommentQuery, E = unknown>(
    variables: SocialGetCommentQueryVariables,
    options?: Omit<UseQueryOptions<SocialGetCommentQuery, E, D, (SocialGetCommentQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialGetCommentQuery, E, D, (SocialGetCommentQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialGetCommentQueryOptions(variables, fetchOptions),
    })
}

export const SocialFollowersFeedDocument = `
query socialFollowersFeed($input: SocialFollowersFeedInput!) {
  socialFollowersFeed(input: $input) {
    posts {
      id
      postSlug
      content
      likesCount
      isLiked
      isSaved
      commentsCount
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
        childComments {
          id
          content
          commentsCount
          likesCount
          createTime
          isLiked
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        profileUrls {
          crafter
          designer
          teacher
          theArtistry
        }
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        location {
          country
        }
        following
        isTemporary
      }
      type
      socialProducts {
        id
        title
        thumbnail
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          profileUrls {
            crafter
            designer
            teacher
            theArtistry
          }
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
        }
        slug
        description
        category
        categorySlug
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      machines
      materials
      instructions
      createTime
      level
      machineItems {
        id
        title
        type
      }
      materialItems {
        id
        title
      }
      themeItems {
        id
        title
      }
      instructionItems {
        description
        assets {
          id
          url
          optimizedUrl
          thumbnailUrls {
            url
            width
          }
          type
          createTime
          videoInfo {
            id
            state
            hls_urls
            mp4_urls
            dash_urls
            thumbnailUrl
          }
        }
      }
    }
    pagination {
      totalPages
      itemsPerPage
      nextPageCursor
    }
    errors {
      code
      message
    }
  }
}

`

export const socialFollowersFeedQueryRootKey = 'socialFollowersFeed'

export function socialFollowersFeedQueryFetcher(variables: SocialFollowersFeedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialFollowersFeedQuery, SocialFollowersFeedQueryVariables>(SocialFollowersFeedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialFollowersFeedQueryKey(variables: SocialFollowersFeedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialFollowersFeedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialFollowersFeedQueryOptions(
    variables: SocialFollowersFeedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialFollowersFeedQuery, unknown, SocialFollowersFeedQuery, (SocialFollowersFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialFollowersFeedQueryKey(variables, fetchOptions),
        queryFn: socialFollowersFeedQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialFollowersFeedQuery<D = SocialFollowersFeedQuery, E = unknown>(
    variables: SocialFollowersFeedQueryVariables,
    options?: Omit<UseQueryOptions<SocialFollowersFeedQuery, E, D, (SocialFollowersFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialFollowersFeedQuery, E, D, (SocialFollowersFeedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialFollowersFeedQueryOptions(variables, fetchOptions),
    })
}

export const SocialSavedFeedDocument = `
query socialSavedFeed($input: SocialSavedFeedInput!) {
  socialSavedFeed(input: $input) {
    totalSavedPosts
    posts {
      id
      postSlug
      content
      likesCount
      isLiked
      isSaved
      commentsCount
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
        childComments {
          id
          content
          commentsCount
          likesCount
          createTime
          isLiked
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        profileUrls {
          crafter
          designer
          teacher
          theArtistry
        }
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        location {
          country
        }
        following
        isTemporary
      }
      type
      socialProducts {
        id
        title
        thumbnail
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          profileUrls {
            crafter
            designer
            teacher
            theArtistry
          }
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
        }
        slug
        description
        category
        categorySlug
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      machines
      materials
      instructions
      createTime
      level
      machineItems {
        id
        title
        type
      }
      materialItems {
        id
        title
      }
      themeItems {
        id
        title
      }
      instructionItems {
        description
        assets {
          id
          url
          optimizedUrl
          thumbnailUrls {
            url
            width
          }
          type
          createTime
          videoInfo {
            id
            state
            hls_urls
            mp4_urls
            dash_urls
            thumbnailUrl
          }
        }
      }
    }
    pagination {
      totalPages
      itemsPerPage
      nextPageCursor
    }
    errors {
      code
      message
    }
  }
}

`

export const socialSavedFeedQueryRootKey = 'socialSavedFeed'

export function socialSavedFeedQueryFetcher(variables: SocialSavedFeedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialSavedFeedQuery, SocialSavedFeedQueryVariables>(SocialSavedFeedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialSavedFeedQueryKey(variables: SocialSavedFeedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialSavedFeedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialSavedFeedQueryOptions(
    variables: SocialSavedFeedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialSavedFeedQuery, unknown, SocialSavedFeedQuery, (SocialSavedFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialSavedFeedQueryKey(variables, fetchOptions),
        queryFn: socialSavedFeedQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialSavedFeedQuery<D = SocialSavedFeedQuery, E = unknown>(
    variables: SocialSavedFeedQueryVariables,
    options?: Omit<UseQueryOptions<SocialSavedFeedQuery, E, D, (SocialSavedFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialSavedFeedQuery, E, D, (SocialSavedFeedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialSavedFeedQueryOptions(variables, fetchOptions),
    })
}

export const SocialCuratedFeedDocument = `
query socialCuratedFeed($input: SocialCuratedFeedInput!) {
  socialCuratedFeed(input: $input) {
    posts {
      id
      postSlug
      content
      likesCount
      isLiked
      isSaved
      commentsCount
      childComments {
        id
        content
        commentsCount
        likesCount
        createTime
        isLiked
        childComments {
          id
          content
          commentsCount
          likesCount
          createTime
          isLiked
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        superSkill
        profileUrls {
          crafter
          designer
          teacher
          theArtistry
        }
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        location {
          country
        }
        following
        isTemporary
      }
      type
      socialProducts {
        id
        title
        thumbnail
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          profileUrls {
            crafter
            designer
            teacher
            theArtistry
          }
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
        }
        slug
        description
        category
        categorySlug
      }
      assets {
        id
        url
        optimizedUrl
        thumbnailUrls {
          url
          width
        }
        type
        videoInfo {
          id
          state
          hls_urls
          mp4_urls
          dash_urls
          thumbnailUrl
        }
      }
      machines
      materials
      instructions
      createTime
      themes
      level
      machineItems {
        id
        title
        type
      }
      materialItems {
        id
        title
      }
      themeItems {
        id
        title
      }
      instructionItems {
        description
        assets {
          id
          url
          optimizedUrl
          thumbnailUrls {
            url
            width
          }
          type
          createTime
          videoInfo {
            id
            state
            hls_urls
            mp4_urls
            dash_urls
            thumbnailUrl
          }
        }
      }
    }
    pagination {
      totalPages
      itemsPerPage
      nextPageCursor
    }
    errors {
      code
      message
    }
  }
}

`

export const socialCuratedFeedQueryRootKey = 'socialCuratedFeed'

export function socialCuratedFeedQueryFetcher(variables: SocialCuratedFeedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialCuratedFeedQuery, SocialCuratedFeedQueryVariables>(SocialCuratedFeedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialCuratedFeedQueryKey(variables: SocialCuratedFeedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialCuratedFeedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialCuratedFeedQueryOptions(
    variables: SocialCuratedFeedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialCuratedFeedQuery, unknown, SocialCuratedFeedQuery, (SocialCuratedFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialCuratedFeedQueryKey(variables, fetchOptions),
        queryFn: socialCuratedFeedQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialCuratedFeedQuery<D = SocialCuratedFeedQuery, E = unknown>(
    variables: SocialCuratedFeedQueryVariables,
    options?: Omit<UseQueryOptions<SocialCuratedFeedQuery, E, D, (SocialCuratedFeedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialCuratedFeedQuery, E, D, (SocialCuratedFeedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialCuratedFeedQueryOptions(variables, fetchOptions),
    })
}